import { PartyForCard } from 'components/service/party/partyRedesignCard/partyType';
import { ifClickable } from '@tock/shared/utils/touchUtils';
import { partyCardCssDefs } from 'components/service/party/partyRedesignCard/partyCardCssDefs';
import { useIsCompactView } from 'hooks/useIsCompactView';
import PartyRedesignDescription from 'components/service/party/partyRedesignCard/PartyRedesignDescription';
import PartyRedesignHeader from 'components/service/party/partyRedesignCard/PartyRedesignHeader';
import PartyRedesignHeaderCompact from 'components/service/party/partyRedesignCard/PartyRedesignHeaderCompact';

interface PartyBodyProps {
  isSelected: boolean;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
  party: PartyForCard;
  hideStatusBar?: boolean;
}

type Props = PartyBodyProps;

const PartyRedesignBody: React.FC<Props> = ({ party, onClick, hideStatusBar }: Props) => {
  const isCompactView = useIsCompactView();
  return (
    <div
      css={partyCardCssDefs.container({ isCompactView, hideStatusBar })}
      onClick={ifClickable(onClick)}
      data-testid="party-card"
    >
      {isCompactView ? (
        <PartyRedesignHeaderCompact party={party} />
      ) : (
        <PartyRedesignHeader party={party} />
      )}
      <PartyRedesignDescription party={party} />
    </div>
  );
};

export default PartyRedesignBody;
